<template>
  <div>
    <div class="content-wrapper">
      <div class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1 class="m-0">Welcome back, {{ usrName }}!</h1>
            </div>
          </div>
        </div>
      </div>

      <!-- Main content -->
      <section class="content">
        <div class="container-fluid">
            <div class="row">
            <div class="col-12 col-sm-6 col-md-3">
                <div class="info-box">
                    <span class="info-box-icon bg-info elevation-1"><i class="fas fa-store"></i></span>

                    <div class="info-box-content">
                        <span class="info-box-text">Restaurant</span>
                        <span class="info-box-number">{{ counter.restaurant }}</span>
                    </div>
                </div>
            </div>
            
            
            <div class="col-12 col-sm-6 col-md-3">
                <div class="info-box mb-3">
                <span class="info-box-icon bg-primary elevation-1"><i class="fas fa-house-user"></i></span>

                <div class="info-box-content">
                    <span class="info-box-text">Outlet</span>
                    <span class="info-box-number">{{ counter.outlet }}</span>
                </div>
                
                </div>
            </div>
            

            <!-- fix for small devices only -->
            <div class="clearfix hidden-md-up"></div>

            <div class="col-12 col-sm-6 col-md-3">
                <div class="info-box mb-3">
                    <span class="info-box-icon bg-success elevation-1"><i class="fas fa-layer-group"></i></span>

                    <div class="info-box-content">
                        <span class="info-box-text">Category</span>
                        <span class="info-box-number">{{ counter.category }}</span>
                    </div>
                </div>
            </div>
            
            <div class="col-12 col-sm-6 col-md-3">
                <div class="info-box mb-3">
                    <span class="info-box-icon bg-warning elevation-1"><i class="fas fa-list"></i></span>

                    <div class="info-box-content">
                        <span class="info-box-text">Menu</span>
                        <span class="info-box-number">{{ counter.food }}</span>
                    </div>
                </div>
            </div>

          </div>      
        </div>
      </section>

      <div class="restaurant-wrapper">
          <Splide :options="{ rewind: true, 
                                perPage: 3, 
                                pagination: false,
                                type: 'loop', 
                                drag: 'free',
                                arrows: true}" 
                    class="slider-wrapper"
                    aria-label="My Favorite Images">
                <SplideSlide v-for="ppl in media" :key="ppl.id">
                    <div class="">
                        <div class="gallery-wrapper" v-if="ppl.name">
                            <img class="gallery-img" :src="getGalleryImg(ppl.name)" :alt="ppl.name">

                            <lord-icon @click="show(ppl.id, ppl.name, 'gallery')"
                                src="https://cdn.lordicon.com/qjwkduhc.json"
                                trigger="hover"
                                colors="primary:#30e849,secondary:#9bbc16,tertiary:#ffffff"
                                style="position: absolute;bottom:0;right:20px;width:80px;height:80px;">
                            </lord-icon>
                        </div>
                    </div> 
                </SplideSlide>
            </Splide>
      </div>

      <div class="col w-100 d-flex justify-content-between mt-5" style="padding: 0px 30px">    
          <label class="custum-file-upload" for="file">
              <div class="icon">
                  <svg xmlns="http://www.w3.org/2000/svg" fill="" viewBox="0 0 24 24"><g stroke-width="0" id="SVGRepo_bgCarrier"></g><g stroke-linejoin="round" stroke-linecap="round" id="SVGRepo_tracerCarrier"></g><g id="SVGRepo_iconCarrier"> <path fill="" d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z" clip-rule="evenodd" fill-rule="evenodd"></path> </g></svg>
              </div>
              <div class="text">
                  <span>Click to upload image</span>
              </div>

              <input name="image" type="file" id="file" ref="file" @input="handleSelects" accept="image/png, image/jpeg">
              
              {{ image_name }}
              <p class="text-danger mt-1">{{ errImage }}</p>
          </label>

          <div v-for="img in images" :key="img">
              <img :src="img" class="preview">
          </div>
      </div>
      
      <div class="col d-flex justify-content-between" style="padding: 0px 30px">
          <button class="btn btn-info w-50" @click="submitForm">Sumbit</button>
      </div>
      
    </div>

    <Modal :itemid="selectedId" :itemname="selectedName" :itemuri="selectedURI" :itemredirect="redirect" v-show="showModal" @closed="onClickChild" />
  </div>
</template>

<script>
import axios from 'axios';
import { Splide, SplideSlide } from '@splidejs/vue-splide';
import '@splidejs/vue-splide/css/sea-green';
import Modal from '@/components/Modal.vue';

export default {
    name: 'HomeView',
    components: {
      Splide, 
      SplideSlide,
      Modal,
    },
    data(){
      return{
        counter: [],
        errImage: null,
        image: null,
        images: [],
        media: [],
        selectedId: null,
        selectedName: null,
        selectedURI: null,
        redirect: null,
        showModal: false,
      }
    },
    computed: {
      usrName(){
        return this.$store.getters.GET_AUTH_INFO.name;
      }
    },
    mounted(){
        this.getCounter()
        this.getMedia()
    },
    methods: {
      getGalleryImg(filename){
        return this.assets + '/images/gallery/' + filename;
      },
      async getMedia(){
        const validToken = this.$store.getters.GET_AUTH_TOKEN;
        const config = {
            headers: { Authorization: `Bearer ` + validToken}
        }

        try {
            let { data } = await axios.get('/media', config)
            this.media = data.data
        } catch(e) {
            console.log(e)
        }
      },
      async getCounter(){
        const validToken = this.$store.getters.GET_AUTH_TOKEN;
        const config = {
            headers: { Authorization: `Bearer ` + validToken}
        }

        try {
            let { data } = await axios.get('/counter', config)
            this.counter = data
        } catch(e) {
            console.log(e)
        }
      },
      submitForm(){
        const validToken = this.$store.getters.GET_AUTH_TOKEN;
        let formData = new FormData();

        formData.append('image', this.image);

        axios.post('/media', formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Access-Control-Allow-Origin': '*',
                'Accept': 'application/json',
                'Authorization': `Bearer ` + validToken,
            }
        })
        .then(() => {
           window.location.href = "/dashboard"
        }).catch(err => {
          console.log(err)
        });

        setTimeout(() => {
            this.errName = null;
            this.errImage = null;
        }, 5000);
    },
    handleSelects(e) {
        this.images = [];
        this.image_name = e.target.files[0].name;
        this.image = e.target.files[0];
        let fileList = Array.prototype.slice.call(e.target.files);
        fileList.forEach(f => {
            if(!f.type.match("image.*")) {
                return;
            }

            let reader = new FileReader();
            let that = this;

            reader.onload = function (e) {
                that.images.push(e.target.result);
            }

            reader.readAsDataURL(f); 
        })
     },
     show(id, name, uri){
        this.selectedId = id;
        this.selectedName = name;
        this.selectedURI = uri;
        this.showModal = true;
        this.redirect = this.$route.name
    },
    onClickChild(value){
        this.showModal = value
    } 
  }
}
</script>

<style>
.gallery-wrapper{
  --main-color: #fff;
  --sub-color: #5b5b5b;
  --bg-color: rgb(154, 188, 22);
  --accent-color: #242C88;
  position: relative;
  display: flex;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
  width: 450px;
  height: 300px;
  padding: 25px;
  border-radius: 25px;
  display: flex;
  flex-direction: column;
  transition: all 0.2s;
  cursor: pointer;
  margin: 20px 20px;
}

.gallery-img{
    width: 100%;
    object-fit: cover;
    border-radius: 10px;
    border: 2px solid #266200;
}
</style>